<template>
  <footer>
    <div class="wrap-xl">
      <a href="https://want.cl" class="logo_footer">
        <img src="../../assets/img/Logo8i.png" />
      </a>

      <div class="text-footer clearfix">
        <p>Escríbenos a <a href="mailto:hola@want.cl" class="a-custom">contacto@8i.cl</a></p>
        <span class="text-span"> Hablemos!: <a href="tel:+56 9 9506 7681">+56 9 9506 7681</a></span>
      </div>
    </div>

    <!-- <div class="copyright col-md-12" style="margin: 0; padding: 0">
      Copyright © 2021 All Rights Reserved by Hanibal.
    </div> -->

    <div class="bc-imagen-footer">
      <div class="pt-background-overley pt-opacity-1 background-footer-c" style="z-index: -1"></div>
    </div>
  </footer>
</template>

<script>
export default {
  data: () => ({}),
};
</script>
